import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class TestDataService {

  private fillDataSubject = new Subject<void>();
  fillDataObserver = this.fillDataSubject.asObservable();

  sameRentalPoint = false;

  fillData() {
    this.fillDataSubject.next();
  }

}
